import { Component, output, viewChild } from '@angular/core';
import { UIIconComponent, UiButtonComponent } from '@design-system';
import { BottomSheetComponent } from '../../../../components/bottom-sheet/bottom-sheet.component';
import { SUPPORT_PHONE_URL } from '../../menu.model';

@Component({
	selector: 'app-support-bottom-sheet',
	imports: [BottomSheetComponent, UIIconComponent, UiButtonComponent],
	templateUrl: './support-bottom-sheet.component.html',
	host: {
		'data-cy': 'support-bottom-sheet'
	}
})
export class SupportBottomSheetComponent {
	private readonly sheet = viewChild<BottomSheetComponent>('sheet');

	readonly chatbotSelected = output<void>();

	readonly phoneUrl = SUPPORT_PHONE_URL;

	open(): Promise<void> {
		return this.sheet()?.open() ?? Promise.resolve();
	}

	close(): Promise<void> {
		return this.sheet()?.close() ?? Promise.resolve();
	}

	onChatbotClick(): void {
		this.close();
		this.chatbotSelected.emit();
	}
}
